<template>
	<v-menu auto>
		<template v-slot:activator="{ on }">
			<v-btn class="menu-icon" color="ocean lighten-3" icon @click="on.click">
				<v-icon small>fas fa-ellipsis-h</v-icon>
			</v-btn>
		</template>

		<v-list>
			<v-list-item v-if="fnMoveToTop" dense @click="() => fnMoveToTop(node)">
				<v-list-item-icon>
					<v-icon small color="ocean">fas fa-arrow-up</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Move to top</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnMoveUp" dense @click="() => fnMoveUp(node)">
				<v-list-item-icon>
					<v-icon small color="ocean">fas fa-angle-up</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Move up</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnMoveDown" dense @click="() => fnMoveDown(node)">
				<v-list-item-icon>
					<v-icon small color="ocean">fas fa-angle-down</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Move down</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item
				v-if="fnMoveToBottom"
				dense
				@click="() => fnMoveToBottom(node)"
			>
				<v-list-item-icon>
					<v-icon small color="ocean">fas fa-arrow-down</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Move to bottom</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-divider v-if="hasMoveItems" />

			<v-list-item v-if="fnEdit" @click="fnEdit">
				<v-list-item-icon>
					<v-icon small color="ocean">far fa-edit</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Edit</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnRemove" @click="fnRemove">
				<v-list-item-icon>
					<v-icon small color="ocean">far fa-trash-alt</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Remove</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	props: {
		node: {
			type: Object,
			required: true,
		},

		fnEdit: { type: Function, required: false },
		fnMoveToTop: { type: Function, required: false },
		fnMoveUp: { type: Function, required: false },
		fnMoveDown: { type: Function, required: false },
		fnMoveToBottom: { type: Function, required: false },
		fnRemove: { type: Function, required: false },
	},

	computed: {
		hasMoveItems() {
			return (
				this.fnMoveToTop ||
				this.fnMoveUp ||
				this.fnMoveDown ||
				this.fnMoveToBottom
			);
		},
	},
};
</script>
